import type { GridApi } from "ag-grid-community";

/** True when at least one group (tree) row is expanded. Leaf rows are skipped. */
export function anyGroupNodeExpanded(api: GridApi): boolean {
  if (api.isDestroyed?.()) return false;
  let anyExpanded = false;
  api.forEachNode((node) => {
    if (node.group && node.expanded) {
      anyExpanded = true;
    }
  });
  return anyExpanded;
}
